class NewsletterPopup {
    init() {
       const $newsletterPopup = $('.newsletter-signup-popup');
       if($newsletterPopup.length) {
          const that = this;

          if($newsletterPopup.data('email') !== undefined && $newsletterPopup.data('email').length){
             const ajaxData = {};
             ajaxData[window.csrfTokenName] = window.csrfTokenValue;
             ajaxData['email'] = $newsletterPopup.data('email');

             $.ajax({
                method: "POST",
                url: 'actions/montavilla/newsletter/check-user-already-subscribed',
                dataType: 'json',
                data: ajaxData,
                success: function(response){
                   if(response.result === 'success' && response.isSubscribed === false && !that.popupIsDismissed()){
                      that.showPopup();
                   }
                }
             })
          }
          else {
             if(!that.popupIsDismissed()){
                that.showPopup();
             }
          }


          $('.js-newsletter-signup-popup--close').on('click', function(e){
             that.setNewsletterPopupCookieAsDismissed();
             $('.newsletter-signup-popup').hide();
          });

          let subscribeIsClicked = false;

          $('#newsletter-popup-submit-button').on('click', function(e){
             let hasErrors = false;
             const email = $('#newsletter_popup_email').val();
             const newsletter_popup_first_name = $('#newsletter_popup_first_name').val();
             const newsletter_popup_last_name = $('#newsletter_popup_last_name').val();
             const email_error = $('#newsletter_popup_email_error');
             const first_name_error = $('#newsletter_popup_first_name_error');
             const last_name_error = $('#newsletter_popup_last_name_error');
             const lists_error = $('#newsletter_popup_lists_error');

             email_error.hide();
             first_name_error.hide();
             last_name_error.hide();
             lists_error.hide();

             const checkboxes = document.querySelectorAll('.newsletter-popup-checkbox');
             let selectedLists = [];
             for(let i = 0; i < checkboxes.length; i++){
                if(checkboxes[i].checked){
                   selectedLists.push(checkboxes[i].value);
                }
             }

             if(subscribeIsClicked === false){
                subscribeIsClicked = true;
                $('.newsletter-subscriptions-fields-second-level').show();
             }

             if(email.length < 1){
                email_error.show();
                hasErrors = true;
             }
             if(newsletter_popup_first_name.length < 1){
                first_name_error.show();
                hasErrors = true;
             }
             if(newsletter_popup_last_name.length < 1){
                last_name_error.show();
                hasErrors = true;
             }

             if(!selectedLists.length){
                lists_error.show();
                hasErrors = true;
             }

             if(!hasErrors) {
                const data = {
                   email: email,
                   lists: selectedLists,
                   firstName: newsletter_popup_first_name,
                   lastName: newsletter_popup_last_name
                };

                data[window.csrfTokenName] = window.csrfTokenValue;

                fetch('actions/montavilla/newsletter/subscribe-to-lists', {
                   method: 'POST',
                   body: JSON.stringify(data),
                   headers: {
                      "Content-Type": "application/json",
                      "X-CSRF-Token" : window.csrfTokenValue
                   }
                })
                   .then(response => {
                      if (!response.ok) {
                         throw new Error(response.statusText)
                      }
                      return response.json();
                   })
                   .then(data => {
                      if(data.result && data.result === 'success'){
                         $('.newsletter-signup-popup--container').hide();
                         $('.newsletter-signup-popup--success-message').show();
                         that.setNewsletterPopupCookieAsDismissed();
                      }
                      else {
                         console.log(data);
                         Swal.showValidationMessage(
                            `Request failed: ${error}`
                         )
                      }
                   })
                   .catch(error => {
                      Swal.showValidationMessage(
                         `Request failed: ${error}`
                      )
                   })
             }
          });
       }
    }

    showPopup() {
       setTimeout(function(){
          $('.newsletter-signup-popup').show();
       }, 5000);
    }

    setNewsletterPopupCookieAsDismissed(){
        $.cookie(this.getNewsletterPopupDismissedCookieHandle(), 'true', { expires: 30, path: '/' });
    }

    getNewsletterPopupDismissedCookieHandle(){
        return 'newsletterCookiePopupDismissed';
    }

    popupIsDismissed(){
        return $.cookie(this.getNewsletterPopupDismissedCookieHandle()) === 'true';
    }
}

export {NewsletterPopup};